import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import AdminAuthContext from "../store/adminStore/admin-auth-context";

const AdminRequireListAuth = ({ route }) => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(AdminAuthContext);

  const clientAccessibilities = clientAuthInfo.accessibilities;

  const foundedObj = clientAccessibilities?.find(
    (clientAcc) => clientAcc.packageName === route.packageName
  );
  // console.log("clientAccessibilities", clientAccessibilities);
  // console.log("route", route);
  // console.log("foundedObj", foundedObj);
  const isAuthorized = foundedObj ? foundedObj.selectAccessList.includes(route.entityName) : false;
  // console.log("isAuthorized", isAuthorized);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        isAuthorized ? (
          <Outlet />
        ) : (
          <Navigate to="/not-authorized" replace state={{ from: location }} />
        )
      ) : (
        <Navigate to="/admin/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default AdminRequireListAuth;
